import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssetVehicleEntryService {

  constructor(private http: HttpClient) { }

  private token = '';

  getvehicletable() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/vehicleAssetTracking/campusWiseVehicles', { headers })
  }

  orafusion(searchorg: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get<any>(environment.employeeURL + '/jwtV2/api/common/buildingDetailsByFusionCode?orcFusionBuildingCode=' + searchorg, { headers });
  }

  getmajor() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/vehicleAssetTracking/majorCategoryList', { headers });
  }

  getminor(major: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/minorCategoryList?majorCatId=' + major, { headers })
  }
  getorganization(fusionCode: any, orgType: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/allOrganizationList?fusionBuildingCodeProd=' + fusionCode + '&' + 'orgType=' + orgType, { headers })
  }

  assetVehicleSave(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.orgUrl + '/apiV2/vehicleAssetTracking/saveVehicleDetails', payload, { headers })
  }

}
